/** 
 * !Warning
 * This implementation might not be as tidy as GSAP's.
 * Target element's innerHTML is completely rewrited using a regex. 
 * Therefore, any reference to elements INSIDE the target is LOST after the split operation (= they are now new sub-elements).
 * Hence please do not store any handle to DOM for inner elements before SplitText operation.
 */
/** @type {Object} options:
 * - @type {string} wordsAttr (default: `[data-w]`)
 * - @type {boolean} splitChars  (default: `false`)
 * - @type {string} charsAttr (default: `[data-c]`)
 * - @type {boolean} debug (default: `false`)
 */
 
export class SplitText {
  
  // here some inspiration to make it more accessible: https://github.com/shshaw/Splitting/issues/19
  
  constructor(selector, options = undefined) {
    // this.lines =
    // this.isSplit = false
    this.chars = []
    this.words = []
    this.options = options
    // this.elements = 
    this.element = typeof selector === 'string' ? document.querySelector(selector) : selector
    
    if (!this.element) return
    // this._originals =
    if (this.element.ariaLabel == undefined) this.element.ariaLabel = this.element.textContent
    this._original = this.element.innerHTML
    
    const output = this.element.innerHTML.replace(/[^> ]+(?![^<]*>)/g, (match) => { 
      return this._split(match) 
    })
    if (this.options?.debug) {
      console.log('innerHTML:\n', this.element.innerHTML)
      
      const texts = this.element.innerHTML.match(/[^> ]+(?![^<]*>)/g)
      console.log('texts:\n', texts)
      
      // console.log('output:\n', output)
    }
    
    this.element.innerHTML = output
    this.element.dataset.split = true
    
    this.chars = [ ...this.element.querySelectorAll('[data-c]') ]
    this.words = [ ...this.element.querySelectorAll('[data-w]') ]
    
    if (this.options?.debug) console.log(this)
    return this
  }
  _split(word) {
    let w = word
    if (this.options?.splitChars) w = word.split('').map(letter => this._strDivify(letter, 'data-c')).join('')
    return this._strDivify(w, 'data-w') // always wrap words with <div>s to prevent undesired word break
  }
  _strDivify(string, dataAttr) {
    const tag = this.options?.tag ?? 'span'
    return `<${tag} ${dataAttr} role="presentation">${string}</${tag}>`
  }
  _divify(string) {
    const el = document.createElement('div')
    el.style.display = 'inline-block'
    el.textContent = string
    return el
  }
  revert() {
    this.element.innerHTML = this._original
    this.element.dataset.split = false
  }
}